import { useEffect } from "react";
import { getId } from "../../../utils/getId";
import { useNavigate } from "react-router-dom";
import { getCurrentMedio } from "../utils/medioTags";

export const useVoteRedirect = ({
    goldenBallInfo,
    hasSpecialVote,
    playersVoted,
    targetPath,
    numberVoted


})=>{
    
    const navigate = useNavigate();
    const editionId = getId(3);

        useEffect(()=>{
            if(!goldenBallInfo || !editionId) return;
            if(playersVoted?.length >= numberVoted || hasSpecialVote && getCurrentMedio(goldenBallInfo, hasSpecialVote)?.hasVoted === true || 
                hasSpecialVote && getCurrentMedio(goldenBallInfo, hasSpecialVote) === 'hack'  ) return navigate(`/voted/${targetPath}/${editionId}`)
            
    
        },[goldenBallInfo, editionId, playersVoted, playersVoted?.length])
}